import { Modal, Row, Col } from 'react-bootstrap';
import React, { useState } from 'react';
import '../scss/components/Modal.scss';
import { RestService } from '../utils';
import ConfigHandler from '../config';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

function QuoteCloneConfirmation({ setShowCloneModal, data, fetchData }) {
  const [show, setShow] = useState(true);
  const { t } = useTranslation();

  const duplicateQuote = () => {
    RestService.post({
      url: `${ConfigHandler.getConfig().api.baseUrl}${ConfigHandler.getConfig().api.path.duplicateQuote}`,
      body: data
    }).then((res) => {
      if (res.status > 199 && res.status < 300) {
        toast.success(`${t('NOTIFICATIONS.NotificationDuplicated')}`);
        window.location.reload(false);
      } else {
        res.json().then((statusText) => {
          toast.error(
            <>
              {t('NOTIFICATIONS.NotificationSomethingWrong')} <br />
              <small>
                <i>{statusText.error}</i>
              </small>
            </>
          );
        });
      }
    });

    setShowCloneModal(false);
  };

  return (
    <>
      <Modal
        show={show}
        fullscreen={false}
        onHide={() => {
          setShow(false);
          setShowCloneModal(false);
        }}
        className="NewQuoteConfirmModal">
        <Modal.Header closeButton>
          <span>{t('MODALS.ConfirmationHeading')}</span>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <p>{t('OTHERS.ConfirmDuplicate')}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <button
                className="fadedBorderButton p-2"
                onClick={() => {
                  setShow(false);
                  setShowCloneModal(false);
                }}>
                {t('MODALS.BackButton')}
              </button>
            </Col>
            <Col>
              <button className="fadedButton p-2" onClick={() => duplicateQuote()}>
                {t('MODALS.ProceedButton')}
              </button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default QuoteCloneConfirmation;
